import { Component, Input } from '@angular/core';

import { TippyDirective } from '@ngneat/helipopper';

@Component({
    selector: 'app-input-error',
    imports: [TippyDirective],
    templateUrl: './input-error.component.html'
})
export class InputErrorComponent {
  @Input() error?: string;
}
